// extracted by mini-css-extract-plugin
module.exports = {"CustomOverlay":"CustomWithSpinner_CustomOverlay__1T6uF","SpinnerContainer":"CustomWithSpinner_SpinnerContainer__3xk7N"};